import React from 'react';
import theme from './NotificationRow.module.scss';
import { classnames } from '@/utils/html';
import { DateDistanceDisplay } from '@/components/localization';
import { CustomLink } from '@/components/navigation';
import BackendIcon, { BackendIconNames } from '@/components/Icons/BackendIcon';
import { ProfileIcon } from '@/components/Icons';
import { INotification } from '@/types';
import { Thumbnail } from '@ygtechnologies/bygr-frontend-component-library';

type Props = {
    notification: INotification;
    onClick?: (notification: INotification) => void;
};

const DeprecatedContent: React.FC<Props> = ({ notification, onClick }) => {
    const handleClick = (e) => {
        if (onClick) {
            onClick(notification);
        }
    };

    if (notification.url) {
        return (
            <CustomLink
                onClick={handleClick}
                className={classnames(theme.notificationRow, theme[notification.status.toLowerCase()])}
                to={notification.url}>
                <DeprecatedRenderIcon notification={notification} />
                <div>
                    <span className={theme.message}>{notification.message}</span>
                    <span className={theme.date}>
                        <DateDistanceDisplay value={notification.createDate} />
                    </span>
                </div>
            </CustomLink>
        );
    }

    return (
        <div onClick={handleClick} className={classnames(theme.notificationRow, theme[notification.status.toLowerCase()])}>
            <DeprecatedRenderIcon notification={notification} />
            <div>
                <span className={theme.message}>{notification.message}</span>
                <span className={theme.date}>
                    <DateDistanceDisplay value={notification.createDate} />
                </span>
            </div>
        </div>
    );
};

const DeprecatedRenderIcon: React.FC<{ notification: INotification }> = ({ notification }) => {
    if (notification.imageUrl) {
        return <Image url={notification.imageUrl} />;
    }
    if (notification.iconName === 'ProfileImage') {
        return <ProfileImage profileId={notification.initiatedByProfileId!} />;
    } else if (notification.iconName) {
        return <Icon iconName={notification.iconName} />;
    } else return <div className={theme.image}></div>;
};

const Image: React.FC<{ url: string }> = ({ url }) => {
    return (
        <div className={theme.image}>
            <Thumbnail src={url} />
        </div>
    );
};

const ProfileImage: React.FC<{ profileId: number }> = ({ profileId }) => {
    return (
        <div className={classnames(theme.image, theme.profileIcon)}>
            <ProfileIcon sizeInPx={44} profileId={profileId!} />
        </div>
    );
};

const Icon: React.FC<{ iconName: BackendIconNames }> = ({ iconName }) => {
    return (
        <div className={theme.image}>
            <BackendIcon iconName={iconName} />
        </div>
    );
};

export default DeprecatedContent;